import {
  formatDate,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Padding,
  TextEllipsis,
  useOutputDescriptionProcessingStatesQuery,
  useSystemClassifierItemsBy,
  Detail,
} from '@atlas-frontend/sdk';
import { Button, Flex } from 'antd';
import { FC } from 'react';
import translations from './OutputDataActionModal.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { ActiveOutputsTable } from './ActiveOutputsTable';
import { OutputDataActionParams } from '../OutputDataDirectory';

const { addTranslations, t } = i18nNsFactory('output-data-action-modal');
addTranslations(translations);

export interface ActiveOutputsModalProps {
  params: OutputDataActionParams;
  onClose: () => void;
}

export const RelatedOutputsModal: FC<ActiveOutputsModalProps> = (props) => {
  const { params, onClose } = props;
  const { hasAccess, ...otherParams } = params;
  const { data, isLoading } =
    useOutputDescriptionProcessingStatesQuery(otherParams);
  const systemClassifierItemsById = useSystemClassifierItemsBy(['FREQUENCY']);

  if (!data) return null;

  return (
    <Modal
      onCancel={onClose}
      width="60rem"
      loading={isLoading}
      footer={
        <ModalFooter>
          <Button
            id="close-active-outputs-modal"
            type="primary"
            onClick={onClose}
          >
            {t('cancel')}
          </Button>
        </ModalFooter>
      }
    >
      <ModalHeader>
        <ModalTitle>
          <TextEllipsis>
            {t('title', { count: data.outputs.length })}
          </TextEllipsis>
        </ModalTitle>
      </ModalHeader>
      <Padding scrollable>
        <Flex vertical gap="small">
          <Detail label={t('group')}>
            {`${data?.groupCode} - ${data.groupName}`}
          </Detail>
          <Detail label={t('valueDate')}>{formatDate(data.valueDate)}</Detail>
          <Detail label={t('frequency')}>
            {systemClassifierItemsById['FREQUENCY'].get(data.frequencyId)?.name}
          </Detail>
        </Flex>
        <Padding top>
          <ActiveOutputsTable
            mode="read"
            selectionMode="none"
            data={data}
            hasGroupAccess={hasAccess}
          />
        </Padding>
      </Padding>
    </Modal>
  );
};
